import {
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { taxStatusGetter } from '../../../grid/utils/value-getters/tax-status';
import { InclusiveExclusiveFilterHandler } from './base/inclusive-exclusive-filter-handler';
export class TaxStatusFilterHandler extends InclusiveExclusiveFilterHandler {
  protected getValue(params: FilterPassParams): string[] {
    return taxStatusGetter({ data: params.deal });
  }

  get name(): string {
    return CalendarGridColumnName.TaxStatus;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.taxStatus = params.filterOptions.taxStatus;
  }

  getFilterOptions(filterOptions: FilterOptions): string[] {
    return convertToStringArray(filterOptions.taxStatus);
  }
}
